import { useMemo } from 'react';
import { useGoalTemplateCategoriesQuery } from 'shared/hooks/queries/use-goal-template-categories-query';

export const useGoalTemplateCategories = () => {
  const { data } = useGoalTemplateCategoriesQuery();

  return useMemo(() => data ?? [], [data]);
};
